<template>
  <div class="userheder">
    <el-form
      :inline="true"
      :model="formSearch"
      ref="formSearch"
      class="demo-form-inline"
    >
      <el-form-item label="日期">
        <el-date-picker
          v-model="formSearch.formdate"
          type="daterange"
          align="right"
          size="small"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="地区">
        <areaMultiSelect
          :value.sync="formSearch.geo"
          :optionsList="countryList"
        >
        </areaMultiSelect>
      </el-form-item>
      <el-form-item label="平台">
        <el-select v-model="formSearch.osType" placeholder="全部">
          <el-option label="全部" :value="null"></el-option>
          <el-option label="android" value="android"></el-option>
          <el-option label="google" value="google"></el-option>
          <el-option label="ios" value="ios"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="产品">
        <product-select
          :value.sync="formSearch.afid"
          :multiple="true"
          class="all-select"
          placeholder="全部产品"
          popper-class="BI-select BI-select-product report_select"
        >
        </product-select>
      </el-form-item>
      <el-form-item label="产品负责人">
        <el-select
          v-model="formSearch.principalUserNameList"
          multiple
          filterable
          collapse-tags
          placeholder="全部"
        >
          <el-checkbox
            @change="selectAllHandler($event, 'principalUserNameList')"
            >全选</el-checkbox
          >
          <el-option
            v-for="(item, index) in principalUserNameListData"
            :key="index"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="工作室">
        <el-select
          v-model="formSearch.productGroupNameList"
          multiple
          filterable
          collapse-tags
          placeholder="全部"
        >
          <el-checkbox
            @change="selectAllHandler($event, 'productGroupNameList')"
            >全选</el-checkbox
          >
          <el-option
            v-for="(item, index) in productGroupNameListData"
            :key="index"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="小组">
        <el-select
          v-model="formSearch.squadNameList"
          multiple
          filterable
          collapse-tags
          placeholder="全部"
        >
          <el-checkbox @change="selectAllHandler($event, 'squadNameList')"
            >全选</el-checkbox
          >
          <el-option
            v-for="(item, index) in squadNameListData"
            :key="index"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="域名组">
        <el-select
          v-model="formSearch.accountGroupCodes"
          multiple
          collapse-tags
          placeholder="请选择域名组"
          clearable
          style="width: 200px"
          size="medium"
        >
          <el-option
            v-for="item in accountGroupCodeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleReset">重置 </el-button>
        <el-button type="primary" @click="handleSearch">查询 </el-button>
        <el-tooltip
          class="item"
          effect="dark"
          content="下载excel"
          placement="top"
        >
          <i
            v-loading="downloadLoading"
            class="el-icon-download"
            style="font-size: 20px; cursor: pointer; margin-left: 10px"
            @click="downloadFile"
          />
        </el-tooltip>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { changeshortcutclass, clearallshortcutclass } from "@/utils/tool";
import areaMultiSelect from "@/components/areaMultiSelect.vue";
import moment from "moment";
import { principalUserList, groupList, squadList } from "@/api/api.js";
export default {
  components: {
    areaMultiSelect,
  },
  computed: {},
  mounted: async function () {
    this.$store.dispatch("getCountryListAndMedia", {
      afid: null,
      cb: (result) => {
        this.countryList = result.countryList;
        const { principalUserNameList, productGroupNameList, squadNameList } =
          this.formSearch;
        let param = {
          dateStart: moment(this.formSearch.formdate[0]).format("YYYYMMDD"),
          dateEnd: moment(this.formSearch.formdate[1]).format("YYYYMMDD"),
          afid: this.formSearch.afid.length
            ? this.formSearch.afid.join()
            : null,
          isisRate: true,
          geo: this.formSearch.geo.join(","),
          osType: this.formSearch.osType,
          type: 1,
          principalUserNameList,
          productGroupNameList,
          squadNameList,
        };
        this.$emit("handleSearch", param);
      },
    });

    await this.loadPrincipalUserOptions();
    await this.loadGroupOptions();
    await this.loadSquadOptions();
  },
  data() {
    return {
      principalUserNameListData: [],
      productGroupNameListData: [],
      squadNameListData: [],
      countryList: [],
      checked: false,
      accountGroupCodeList: JSON.parse(
        localStorage.getItem("accountGroupCodeList") || "[]"
      ),
      formSearch: {
        formdate: [
          new Date(new Date().getTime() - 3600 * 1000 * 24 * 6),
          new Date(),
        ],
        afid: [],
        osType: null,
        geo: [],
        principalUserNameList: [],
        productGroupNameList: [],
        squadNameList: [],
        accountGroupCodes: [],
      },
      downloadLoading: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "当天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("当天", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一周", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一个月", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近2个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近2个月", picker.$el);
              }, 0);
            },
          },
        ],
        onPick: function ({ maxDate, minDate }) {
          clearallshortcutclass(this.$el);
          console.log(maxDate, minDate);
        },
        // disabledDate: function(time) {
        //   return time.getTime() > Date.now();
        // }
        disabledDate: function (date) {
          if (new Date().getTime() - date.getTime() > 0) {
            return false;
          }
          return true;
        },
      },
    };
  },
  methods: {
    selectAllHandler(value, key) {
      if (!value) return (this.formSearch[key] = []);
      this.formSearch[key] = this[key + "Data"].map((item) => item.name);
    },
    async loadPrincipalUserOptions() {
      try {
        this.$emit("showLoading", true);
        const { code, data, msg } = await principalUserList();
        if (code !== "0000") return this.$message.error(msg);

        this.principalUserNameListData = data;
      } finally {
        this.$emit("showLoading", false);
      }
    },
    async loadGroupOptions() {
      try {
        this.$emit("showLoading", true);
        const { code, data, msg } = await groupList();
        if (code !== "0000") return this.$message.error(msg);
        this.productGroupNameListData = data;
      } finally {
        this.$emit("showLoading", false);
      }
    },
    async loadSquadOptions() {
      try {
        this.$emit("showLoading", true);
        const { code, data, msg } = await squadList();
        if (code !== "0000") return this.$message.error(msg);
        this.squadNameListData = data;
      } finally {
        this.$emit("showLoading", false);
      }
    },
    handleReset() {
      this.formSearch = {
        formdate: [
          new Date(new Date().getTime() - 3600 * 1000 * 24 * 6),
          new Date(),
        ],
        afid: [],
        osType: null,
        geo: [],
        principalUserNameList: [],
        productGroupNameList: [],
        squadNameList: [],
        accountGroupCodes: [],
      };
      this.handleSearch();
    },
    handleSearch() {
      const { principalUserNameList, productGroupNameList, squadNameList } =
        this.formSearch;

      let param = {
        dateStart:
          this.formSearch.formdate && this.formSearch.formdate[0]
            ? moment(this.formSearch.formdate[0]).format("YYYYMMDD")
            : null,
        dateEnd:
          this.formSearch.formdate && this.formSearch.formdate[1]
            ? moment(this.formSearch.formdate[1]).format("YYYYMMDD")
            : null,
        afid: this.formSearch.afid.length ? this.formSearch.afid.join() : null,
        isisRate: true,
        geo: this.formSearch.geo.join(","),
        osType: this.formSearch.osType,
        type: 1,
        principalUserNameList,
        productGroupNameList,
        squadNameList,
        accountGroupCodes: this.formSearch.accountGroupCodes.length
          ? [...this.formSearch.accountGroupCodes]
          : undefined,
      };
      this.$emit("handleSearch", param);
    },
    closeDownLoadLoading() {
      this.downloadLoading = false;
    },
    downloadFile() {
      this.downloadLoading = true;
      this.$emit("downloadFile");
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@borderline: #e6e6e6;

.el-date-editor--daterange {
  width: 300px;
}

// .el-button {
//   margin-left: 186px;
// }
.userheder {
  padding: 10px;
  // border: 1px solid #e6e6e6;
  margin: 2px;
  border-radius: 3px;
  align-items: baseline;
  display: flex;
  min-width: 1200px;
}

.headerleft {
  text-align: right;

  i {
    font-size: 20px;
    margin-right: 10px;
    cursor: pointer;
  }

  i:hover {
    color: #409eff;
  }
}

.el-form-item {
  margin-bottom: 0px;
}

.date {
  margin-bottom: 10px;
}

.el-checkbox {
  width: 95%;
  text-align: right;
}
</style>
<style lang="less">
.all-select .el-select__tags-text {
  max-width: 62px;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.all-select .el-tag__close {
  margin-bottom: 13px;
}

.report_select ul li:nth-child(2) {
  // margin-top: 2% !important;
}
</style>
